import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Modal from './Modal';
import ContactForm from './ContactForm';
import ClientLogoStrip from './ClientLogoStrip';

// Module scope: a stable reference, so the rotation effect doesn't need it as a dependency.
const PHRASES = ["building", "shipping", "scaling"];

const Hero = () => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [showContactModal, setShowContactModal] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentPhraseIndex((i) => (i + 1) % PHRASES.length);
        setIsVisible(true);
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handlePrimaryClick = () => {
    setShowContactModal(true);
  };

  const closeContactModal = () => {
    setShowContactModal(false);
  };

  return (
    <>
      <section className="hero">
        <div className="hero-content hero-content-centered">
          <div className="hero-text hero-text-centered">
            {/* This is a site about a person; the person should be visible before
                the fold rather than only on /about. */}
            <img
              src="/alek_hagopian.jpg"
              alt="Alek Hagopian"
              className="hero-portrait"
              width="96"
              height="96"
            />
            <p className="hero-overline">ALEK HAGOPIAN — AI &amp; DATA</p>
            <h1>
              I help companies stop talking about AI, and start&nbsp;
              <span className={`rotating-text ${isVisible ? 'visible' : 'hidden'}`}>
                {PHRASES[currentPhraseIndex]}.
              </span>
            </h1>
            <p className="hero-subtitle">
              I've spent a decade building data and AI systems — as a consultant at Mastercard,
              as a founder who sold his own AI company, and now independently for teams that need
              the thing actually built. I also make software of my own.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary" onClick={handlePrimaryClick}>
                Work with me →
              </button>
              <Link to="/apps" className="btn btn-secondary">
                See my apps
              </Link>
            </div>
            {/* Replaces the old plain trust line — the strip carries the same claim
                and the logos that back it. */}
            <ClientLogoStrip />
          </div>
        </div>
      </section>

      <Modal
        isOpen={showContactModal}
        onClose={closeContactModal}
        title="Start a conversation"
      >
        <ContactForm onClose={closeContactModal} />
      </Modal>
    </>
  );
};

export default Hero;
